import { motion, AnimatePresence } from 'framer-motion';
import { useChatApi } from '../Services/ChatApiProvider';

const WelcomeBox = ({ isChatActive, chatType }) => {
  const { channelSettings } = useChatApi();
  const firstLine = (channelSettings?.firstLineText ?? '').toString().trim() || 'Вітаю👋';
  const secondLine =
    (channelSettings?.secondLineText ?? '').toString().trim() || 'Як можу тобі допомогти?';

  return (
    <AnimatePresence>
      {chatType === 'widget' && !isChatActive && (
        <motion.div key="welcome-box" className="welcome-box">
          <span className="welcome-title">{firstLine}</span>
          <div className="title-and-subtitle">
            <h1>{secondLine}</h1>
          </div>
        </motion.div>
      )}

      {chatType === 'static-box' && (
        <motion.div key="welcome-box" className="welcome-box">
          <span className="welcome-title">{firstLine}</span>
          <div className="title-and-subtitle">
            <h1>{secondLine}</h1>
            <div className="sure-subtitle">
              SUR<i>E</i> Support <span>Agent</span>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default WelcomeBox;
